// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__vh5Ks","title":"InfoRow_title__3l6us"};